import { Link } from 'react-router-dom'
import { LogOut, User } from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { roleLabel } from '@/lib/roles'

interface UserMenuProps {
  user: { firstName: string; lastName: string; email: string; role: string } | null
  onLogout: () => void
}

/** Menu da pessoa logada: perfil e sair (configurações ficam no menu lateral). */
export function UserMenu({ user, onLogout }: UserMenuProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" className="gap-2">
          <User className="size-5" />
          <span className="hidden text-sm font-medium sm:inline">{user?.firstName}</span>
          <span className="sr-only sm:hidden">Menu de {user?.firstName}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        <DropdownMenuLabel className="flex flex-col gap-0.5">
          <span className="text-sm font-medium text-foreground">{user?.firstName} {user?.lastName}</span>
          <span className="text-xs font-normal text-muted-foreground">{user?.email}</span>
          <span className="text-xs font-medium text-primary">{roleLabel(user?.role)}</span>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem asChild>
          <Link to="/profile"><User /> Meu perfil</Link>
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem variant="destructive" onSelect={onLogout}>
          <LogOut /> Sair
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
